import { FormBase } from 'core/components';

export default class ApplicationSettingEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'name',
                    label: 'Name',
                },
                {
                    name: 'applicationSettingCategoryId',
                    label: 'Category Id',
                },      
                {
                    name: 'value',
                    label: 'Value',
                    placeholder: 'Enter Value',
                    rules: 'string|required'
                }             
            ],
        };
    }
}
